"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_ShockShield_OnDamageEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_ShockShield_OnDamageEventHandlerScript = class Effect_ShockShield_OnDamageEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Damaged) {
            return;
        }
        if (event.args.damagedBy !== handler.args.scriptArgs.damager) {
            return;
        }
        const damageAbsorption = Math.round(handler.args.scriptArgs.percentDamageAbsorption * event.args.damage.amount / 100);
        container.applyBuff({
            sequence,
            creatorId: handler.args.scriptArgs.damager,
            targetId: handler.args.scriptArgs.damager,
            effect: new __1.DamageAbsorbEffectArgs({
                [__1.DamageType.All]: damageAbsorption
            }, damageAbsorption),
            duration: Duration_1.Duration.Permanent,
        });
    }
};
Effect_ShockShield_OnDamageEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_ShockShield_OnDamage")
], Effect_ShockShield_OnDamageEventHandlerScript);
exports.Effect_ShockShield_OnDamageEventHandlerScript = Effect_ShockShield_OnDamageEventHandlerScript;
